import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class ReportStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'ReportStore',
			properties: ['customerByDate'],
		});
	}

	customerByDate = {};

	reset = () => {
		this.customerByDate = {};
	};

	setCustomerByDate = async state => {
		runInAction(async () => {
			this.customerByDate = state;
		});
	};
}
